import { render, staticRenderFns } from "./StickyRequestButton.vue?vue&type=template&id=4ad5883c&scoped=true"
import script from "./StickyRequestButton.vue?vue&type=script&lang=ts"
export * from "./StickyRequestButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5883c",
  null
  
)

export default component.exports